"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angle_axis_1 = __importDefault(require("./angle-axis"));
var aria_1 = __importDefault(require("./aria"));
var axis_pointer_1 = __importDefault(require("./axis-pointer"));
var brush_1 = __importDefault(require("./brush"));
var calendar_1 = __importDefault(require("./calendar"));
var data_zoom_1 = __importDefault(require("./data-zoom"));
var geo_1 = __importDefault(require("./geo"));
var graphic_1 = __importDefault(require("./graphic"));
var grid_1 = __importDefault(require("./grid"));
var legend_1 = __importDefault(require("./legend"));
var parallel_1 = __importDefault(require("./parallel"));
var parallel_axis_1 = __importDefault(require("./parallel-axis"));
var polar_1 = __importDefault(require("./polar"));
var radar_1 = __importDefault(require("./radar"));
var radius_axis_1 = __importDefault(require("./radius-axis"));
var single_axis_1 = __importDefault(require("./single-axis"));
var state_animation_1 = __importDefault(require("./state-animation"));
var text_style_1 = __importDefault(require("./text-style"));
var timeline_1 = __importDefault(require("./timeline"));
var title_1 = __importDefault(require("./title"));
var toolbox_1 = __importDefault(require("./toolbox"));
var tooltip_1 = __importDefault(require("./tooltip"));
var visual_map_1 = __importDefault(require("./visual-map"));
var x_axis_1 = __importDefault(require("./x-axis"));
var y_axis_1 = __importDefault(require("./y-axis"));
exports.default = {
    angleAxis: angle_axis_1.default,
    aria: aria_1.default,
    axisPointer: axis_pointer_1.default,
    brush: brush_1.default,
    calendar: calendar_1.default,
    dataZoom: data_zoom_1.default,
    geo: geo_1.default,
    graphic: graphic_1.default,
    grid: grid_1.default,
    legend: legend_1.default,
    parallel: parallel_1.default,
    parallelAxis: parallel_axis_1.default,
    polar: polar_1.default,
    radar: radar_1.default,
    radiusAxis: radius_axis_1.default,
    singleAxis: single_axis_1.default,
    stateAnimation: state_animation_1.default,
    textStyle: text_style_1.default,
    timeline: timeline_1.default,
    title: title_1.default,
    toolbox: toolbox_1.default,
    tooltip: tooltip_1.default,
    visualMap: visual_map_1.default,
    xAxis: x_axis_1.default,
    yAxis: y_axis_1.default,
    darkMode: undefined,
    color: [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#9a60b4",
        "#ea7ccc"
    ],
    backgroundColor: "transparent",
    animation: true,
    animationThreshold: 2000,
    animationDuration: 1000,
    animationEasing: "cubicOut",
    animationDelay: 0,
    animationDurationUpdate: 300,
    animationEasingUpdate: "cubicInOut",
    animationDelayUpdate: 0,
    blendMode: "source-over",
    hoverLayerThreshold: 3000,
    useUTC: false // 是否使用UTC时间
};
//# sourceMappingURL=index.js.map